import * as React from "react";
import { Slider } from "@teliaee/react-slick";
import fscreen from "fscreen";
import { Button } from "../../../button/button.mjs";
import debounce from "debounce";
import "tabbable";
import { InputContext } from "../../../helpers/input-provider/input-provider.mjs";
import { useLabels } from "../../../helpers/label-provider/use-labels.mjs";
import { CarouselPreviewItem } from "../carousel-preview-item/carousel-preview-item.mjs";
const CarouselPreview = (props) => {
  const { input } = React.useContext(InputContext);
  const labels = useLabels();
  return /* @__PURE__ */ React.createElement(CarouselPreviewInner, { ...props, input, labels });
};
class CarouselPreviewInner extends React.Component {
  constructor(props) {
    super(props);
    this.element = null;
    this.slick = null;
    this.imageElements = [];
    this.timeout = 0;
    this.handlePanning = (event) => {
      this.setPanningLocation([event.clientY, event.clientX]);
    };
    this.setPanningLocation = (eventCoords) => {
      var _a, _b, _c;
      const currentImage = this.getCurrentImage();
      if (currentImage) {
        if (this.props.input === "touch") {
          const imageContainer = (_b = (_a = currentImage.parentElement) == null ? void 0 : _a.parentElement) == null ? void 0 : _b.parentElement;
          if (imageContainer) {
            const xCoord = imageContainer.clientWidth < imageContainer.scrollWidth ? (imageContainer.scrollWidth - imageContainer.clientWidth) / 2 : 0;
            const yCoord = imageContainer.clientHeight < imageContainer.scrollHeight ? (imageContainer.scrollHeight - imageContainer.clientHeight) / 2 : 0;
            if (xCoord || yCoord) {
              imageContainer.scroll(xCoord, yCoord);
            }
          }
        } else {
          const imageContainer = (_c = currentImage.parentElement) == null ? void 0 : _c.parentElement;
          if (imageContainer && this.state.isPanning) {
            if (imageContainer.parentElement) {
              imageContainer.parentElement.scroll(0, 0);
            }
            const dest = this.getImageOffset(this.state.currentSlide);
            if (eventCoords) {
              const contH = imageContainer.clientHeight;
              const contW = imageContainer.clientWidth;
              const imageH = currentImage.offsetHeight;
              const imageW = currentImage.offsetWidth;
              const coords = [
                (eventCoords ? eventCoords[0] : 0) - imageContainer.getBoundingClientRect().top,
                (eventCoords ? eventCoords[1] : 0) - imageContainer.getBoundingClientRect().left
              ];
              if (imageH >= contH) {
                dest.top = Math.round((imageH - contH) * (coords[0] / contH)) * -1;
              }
              if (imageW >= contW) {
                dest.left = Math.round((imageW - contW) * (coords[1] / contW)) * -1;
              }
            }
            this.setState({
              imageStyle: this.convertOffsetToStyle(dest)
            });
          } else {
            this.setState({
              imageStyle: {}
            });
          }
        }
      }
    };
    this.handleFullScreenChange = () => {
      if (!fscreen.fullscreenElement && this.state.isPanning) {
        this.setState({
          imageStyle: {},
          isPanning: false
        });
      }
    };
    this.handleZoomClick = () => {
      if (fscreen.fullscreenEnabled && this.element) {
        if (fscreen.fullscreenElement) {
          fscreen.exitFullscreen();
        } else {
          fscreen.requestFullscreen(this.element);
        }
      }
      this.setState((prevState) => ({
        isPanning: !prevState.isPanning
      }));
      if (this.state.isPanning) {
        this.setState({
          imageStyle: {}
        });
      }
    };
    this.state = {
      currentSlide: 0,
      nextSlide: 0,
      imageStyle: {},
      nextImageStyle: {},
      isMounted: false,
      isPanning: false
    };
    this.debouncedMousemoveHandler = debounce(this.handlePanning, 0);
  }
  componentDidMount() {
    this.setState({
      isMounted: true
    });
    fscreen.addEventListener("fullscreenchange", this.handleFullScreenChange);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.isPanning !== this.state.isPanning) {
      if (this.props.onZoomChange) {
        this.props.onZoomChange(this.state.isPanning);
      }
      if (this.state.isPanning) {
        this.bindImagePanningListeners();
        this.timeout = window.setTimeout(() => this.setPanningLocation(), 50);
      } else {
        this.removeImagePanningListeners();
      }
    }
    if (prevProps.input !== this.props.input) {
      if (this.props.input === "mouse" && this.state.isPanning) {
        this.bindImagePanningListeners();
      } else if (prevProps.input === "mouse" && this.state.isPanning) {
        this.removeImagePanningListeners();
      }
    }
  }
  componentWillUnmount() {
    this.removeImagePanningListeners();
    fscreen.removeEventListener("fullscreenchange", this.handleFullScreenChange);
    this.debouncedMousemoveHandler.clear();
    window.clearTimeout(this.timeout);
  }
  bindImagePanningListeners() {
    const currentImage = this.getCurrentImage();
    if (currentImage && this.props.input === "mouse") {
      const imageContainer = currentImage.parentElement;
      if (imageContainer) {
        imageContainer.addEventListener("mousemove", this.debouncedMousemoveHandler);
        imageContainer.addEventListener("pointermove", this.debouncedMousemoveHandler);
        imageContainer.addEventListener("MSPointerMove", this.debouncedMousemoveHandler);
      }
    }
  }
  removeImagePanningListeners() {
    const currentImage = this.getCurrentImage();
    if (currentImage) {
      const imageContainer = currentImage.parentElement;
      if (imageContainer) {
        imageContainer.removeEventListener("mousemove", this.debouncedMousemoveHandler);
        imageContainer.removeEventListener("pointermove", this.debouncedMousemoveHandler);
        imageContainer.removeEventListener("MSPointerMove", this.debouncedMousemoveHandler);
      }
    }
  }
  getCurrentImage() {
    return this.imageElements[this.state.currentSlide];
  }
  BEM() {
    const classArray = ["carousel-preview"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    if (this.state.isPanning) {
      classArray.push("is-panning");
    }
    return classArray.join(" ");
  }
  getSliderOptions() {
    return {
      beforeChange: ({}, nextSlide) => {
        if (this.state.nextSlide !== nextSlide) {
          this.setState({
            nextSlide,
            nextImageStyle: this.convertOffsetToStyle(this.getImageOffset(nextSlide))
          });
        }
      },
      afterChange: (currentSlide) => {
        if (this.state.isPanning) {
          this.bindImagePanningListeners();
        }
        this.setState(
          {
            currentSlide,
            imageStyle: this.state.nextImageStyle
          },
          () => {
            this.setPanningLocation();
          }
        );
        if (this.props.onActiveItemChange) {
          this.props.onActiveItemChange(currentSlide);
        }
      },
      arrows: true,
      customPaging: (i) => {
        const children = React.Children.toArray(this.props.children).filter((child) => {
          return React.isValidElement(child) && child.type === CarouselPreviewItem;
        });
        return /* @__PURE__ */ React.createElement("div", { className: "carousel-preview__thumbnail" }, children[i]);
      },
      dots: true,
      dotsClass: "carousel-preview__thumbnail-wrapper",
      draggable: false,
      easing: "cubic-bezier(0.25, 0.1, 0.25, 1.000)",
      fade: true,
      nextArrow: /* @__PURE__ */ React.createElement(CarouselNavNext, { text: this.props.nextArrowText }),
      pauseOnHover: false,
      prevArrow: /* @__PURE__ */ React.createElement(CarouselNavPrev, { text: this.props.prevArrowText }),
      swipe: !this.state.isPanning,
      waitForAnimate: false
    };
  }
  mapChildren() {
    const children = React.Children.toArray(this.props.children).filter((child) => {
      return React.isValidElement(child) && child.type === CarouselPreviewItem;
    });
    const isTouch = this.props.input === "touch";
    return children.map((child, index) => {
      const isCurrent = this.state.currentSlide === index;
      const isNext = this.state.nextSlide === index;
      let imageStyle;
      if (isNext) {
        imageStyle = this.state.nextImageStyle;
      }
      if (isCurrent) {
        imageStyle = this.state.imageStyle;
      }
      return React.cloneElement(child, {
        imageRef: (e) => this.imageElements[index] = e,
        imageStyle: !isTouch ? imageStyle : void 0,
        onClick: this.handleZoomClick
      });
    });
  }
  getImageOffset(imageIndex) {
    var _a;
    const image = this.imageElements[imageIndex];
    const imageContainer = (_a = image.parentElement) == null ? void 0 : _a.parentElement;
    if (imageContainer && this.state.isPanning) {
      const contH = imageContainer.clientHeight;
      const contW = imageContainer.clientWidth;
      const imageH = image.offsetHeight;
      const imageW = image.offsetWidth;
      return {
        left: -(imageW >= contW ? Math.round((contW - imageW) / -2) : 0),
        top: -(imageH >= contH ? Math.round((contH - imageH) / -2) : 0)
      };
    }
    return {
      left: 0,
      top: 0
    };
  }
  convertOffsetToStyle(offset) {
    if (offset) {
      return {
        transform: "translate(".concat(offset.left, "px, ").concat(offset.top, "px)")
      };
    }
    return {};
  }
  renderZoomButton() {
    const { labels } = this.props;
    return /* @__PURE__ */ React.createElement(
      Button,
      {
        className: "carousel-preview__button",
        text: this.state.isPanning ? labels.get("zoomOut") : labels.get("zoomIn"),
        variant: "secondary",
        icon: this.state.isPanning ? "#zoom-out" : "#zoom-in",
        onClick: this.handleZoomClick
      }
    );
  }
  render() {
    const shouldUseSlick = this.state.isMounted && React.Children.count(this.props.children) > 0;
    const CarouselPreviewTag = shouldUseSlick ? Slider : "div";
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM(), ref: (element) => this.element = element }, /* @__PURE__ */ React.createElement("div", { className: "carousel-preview__wrapper" }, /* @__PURE__ */ React.createElement(
      CarouselPreviewTag,
      {
        className: "carousel-preview__slider",
        ref: (slider) => this.slick = slider,
        ...shouldUseSlick && this.getSliderOptions()
      },
      this.mapChildren()
    )), !this.props.noZoom && this.renderZoomButton());
  }
}
const CarouselNavNext = (props) => {
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      ...props,
      icon: "#arrow-right",
      variant: "secondary",
      size: "small",
      className: "".concat(props.className, " carousel-preview__nav carousel-preview__nav--next")
    }
  );
};
const CarouselNavPrev = (props) => {
  return /* @__PURE__ */ React.createElement(Button, { ...props, icon: "#arrow-left", variant: "secondary", size: "small", className: "".concat(props.className, " carousel-preview__nav carousel-preview__nav--prev") });
};
export {
  CarouselPreview
};
